/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Client,
  GetClients200Response,
  StoreClientRequest,
  UpdateClientRequest,
} from '../models/index';
import {
    ClientFromJSON,
    ClientToJSON,
    GetClients200ResponseFromJSON,
    GetClients200ResponseToJSON,
    StoreClientRequestFromJSON,
    StoreClientRequestToJSON,
    UpdateClientRequestFromJSON,
    UpdateClientRequestToJSON,
} from '../models/index';

export interface CreateClientRequest {
    StoreClientRequest?: StoreClientRequest;
}

export interface GetClientRequest {
    client_id: number;
}

export interface GetClientsRequest {
    search?: string;
    page?: number;
    per_page?: number;
}

export interface UpdateClientOperationRequest {
    client_id: string;
    UpdateClientRequest?: UpdateClientRequest;
}

/**
 * 
 */
export class ClientsApi extends runtime.BaseAPI {

    /**
     * Create Client
     */
    async createClientRaw(requestParameters: CreateClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Client>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clients`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StoreClientRequestToJSON(requestParameters['StoreClientRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientFromJSON(jsonValue));
    }

    /**
     * Create Client
     */
    async createClient(requestParameters: CreateClientRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Client> {
        const response = await this.createClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Client
     */
    async getClientRaw(requestParameters: GetClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Client>> {
        if (requestParameters['client_id'] == null) {
            throw new runtime.RequiredError(
                'client_id',
                'Required parameter "client_id" was null or undefined when calling getClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clients/{client_id}`.replace(`{${"client_id"}}`, encodeURIComponent(String(requestParameters['client_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientFromJSON(jsonValue));
    }

    /**
     * Get Client
     */
    async getClient(requestParameters: GetClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Client> {
        const response = await this.getClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Clients
     */
    async getClientsRaw(requestParameters: GetClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClients200Response>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['per_page'] != null) {
            queryParameters['per_page'] = requestParameters['per_page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clients`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClients200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Clients
     */
    async getClients(requestParameters: GetClientsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClients200Response> {
        const response = await this.getClientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Client
     */
    async updateClientRaw(requestParameters: UpdateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Client>> {
        if (requestParameters['client_id'] == null) {
            throw new runtime.RequiredError(
                'client_id',
                'Required parameter "client_id" was null or undefined when calling updateClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clients/{client_id}`.replace(`{${"client_id"}}`, encodeURIComponent(String(requestParameters['client_id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClientRequestToJSON(requestParameters['UpdateClientRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientFromJSON(jsonValue));
    }

    /**
     * Update Client
     */
    async updateClient(requestParameters: UpdateClientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Client> {
        const response = await this.updateClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
